import "./Social.css";
import twitter from "../../assets/twitter.svg";
import youtube from "../../assets/youtube.svg";
import github from "../../assets/github.svg";
function Social() {
  return (
    <div className="social_card">
      <div className="social_title">Connect with us</div>
      <div className="social">
        <a href="https://github.com/AmeNetwork" target="blank">
          <div data-text="Github" className="glass social_github">
            <div className="glass_img"><img src={github} width="100%"></img></div>
            
          </div>
        </a>
        <a href="https://x.com/0xAmeNetwork" target="blank">
          <div data-text="Twitter" className="glass social_twitter">
            <div className="glass_img"><img src={twitter} width="100%"></img></div>
          </div>
        </a>
        <a href="https://www.youtube.com/@amenetwork" target="blank">
          <div data-text="Youtube" className="glass social_youtube">
             <div className="glass_img"><img src={youtube} width="100%"></img></div>
          </div>
        </a>
      </div>
    </div>
  );
}

export default Social;
